import React from "react";
import styled from "styled-components/native";
import { useWindowDimensions } from 'react-native';
import THEME from "../../../config/theme";

export const ModalBackground = styled.View`
  flex: 1;
  justify-content: center;
  align-items: center;
  padding: 16px;
  background-color: rgba(17, 24, 39, 0.55);
`;

const StyledModalContainer = styled.View`
  border-radius: 16px;
  background-color: white;
  align-items: center;
  width: ${({ $width }) => $width}px;
  max-width: 780px;
  max-height: ${({ $maxHeight }) => $maxHeight}px;
  overflow: hidden;
`;

// Componente (não só styled.View estático) para reagir a mudanças de tamanho
// da janela — redimensionar a janela do navegador (ex.: Macbook em modo split)
// ou girar o celular precisa recalcular a largura/altura do modal, não travar
// no valor lido uma única vez quando o módulo foi importado.
export const ModalContainer = ({ children, ...rest }) => {
  const { width, height } = useWindowDimensions();
  const computedWidth = width > 980 ? Math.min(width * 0.6, 780) : width * 0.92;

  return (
    <StyledModalContainer $width={computedWidth} $maxHeight={height * 0.9} {...rest}>
      {children}
    </StyledModalContainer>
  );
};

export const Header = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background-color: #ffffff;
  border-bottom-width: 1px;
  border-bottom-color: #e5e7eb;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  padding: 16px 20px;
`;

export const CloseButton = styled.TouchableOpacity`
  padding: 8px;
  border-radius: 8px;
`;

export const Content = styled.ScrollView`
  width: 100%;
  padding: 0 16px;
  background-color: #f7f8fa;
  flex-grow: 1;
`;

export const ScrollContainer = styled.ScrollView`
  width: 100%;
  flex-grow: 1;
`;

export const ViewSectionAdmin = styled.View`
 padding: 1rem 0rem;
 flex-basis: auto;
 background-color: ${THEME.COLORS.BACKGROUND_ABOUT};
`;


export const ViewButton = styled.View`
 padding: 0.5rem 0rem;
 align-items: center;
 justify-content: center;
 flex-direction: row;
`;


export const ViewTextInput = styled.View`
padding: 0.5rem;
 `;

export const ViewRow = styled.View`
flex-direction: row;
align-items: center;
 `;


export const ViewDataTable = styled.View`
 padding-horizontal: 30px;
`;


export const ViewModal = styled.ScrollView.attrs({
  showsVerticalScrollIndicator: true,
  contentContainerStyle: {
    alignItems: "center",
    padding: "2rem",
    backgroundColor: "#FFFFFF",
    justifyContent: "center",
  },
})` 
`;

export const ViewSwitch = styled.View`
 align-items: center;
 justify-content: center;
 flex-direction: row;
`;

export const ViewDescription = styled.View`
 justify-content: center;
 padding: 1rem 0rem 0rem 0rem;
`;

export const ContentIcon = styled.View`
 position: absolute;
 bottom: 24px;
 right: 24px;
 background-color: #01C3CC;
 border-radius: 999px;
 z-index: 99999;
 width: 56px;
 height: 56px;
 justify-content: center;
 align-items: center;
`;

export const Container = styled.ScrollView.attrs({
  showsVerticalScrollIndicator: true,
  contentContainerStyle: {
    flexGrow: 1,
    backgroundColor: "#F7F8FA",
    paddingBottom: "5rem"
  },
})``;